/**
 * sticky_call_controller.js — a slim Call bar on a /find listing page.
 *
 * The page's own Call button sits in its header. Once that button has
 * scrolled up out of view, a bar pinned to the bottom of the screen carries
 * the same tel: link, so calling is one tap wherever the visitor is reading.
 * It hides again when the header comes back into view. Phone widths only:
 * directory.css keeps the bar out of wide layouts.
 *
 * Targets: actions (the header's action row), bar (the pinned link).
 * Template: templates/directory/listing.html.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['actions', 'bar'];

    connect() {
        if (!this.hasBarTarget || !('IntersectionObserver' in window)) return;
        this._observer = new IntersectionObserver(([entry]) => {
            // Shown only after scrolling past the header, never above it.
            this.barTarget.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
        this._observer.observe(this.actionsTarget);
    }

    disconnect() {
        if (this._observer) this._observer.disconnect();
    }
}
